/*=========================================================================================
  File Name: moduleIndicatorActions.js
  Description: Indicator Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Felix Masa
==========================================================================================*/

import Api from "@/helpers/api.js";
import Indicator from "@/models/Indicator.js";

export default {
	addIndicatorItem({commit, dispatch}, indicator) {
		return new Promise((resolve, reject) => {
			Api.post("/indicator", indicator)
				.then((response) => {
					const newIndicator = new Indicator(Object.assign(indicator, {id: response.data.id}));
					commit("ADD_INDICATOR_ITEM", newIndicator);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchIndicatorListItems({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/indicator")
				.then((response) => {
					commit("SET_INDICATORS", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchIndicatorById({commit}, indicatorId) {
		return new Promise((resolve, reject) => {
			Api.get(`/indicator/${indicatorId}`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateIndicatorItem({commit}, indicator) {
		return new Promise((resolve, reject) => {
			Api.put(`/indicator/${indicator.id}`, indicator)
				.then((response) => {
					const upIndicator = new Indicator(indicator);
					commit("UPDATE_INDICATOR", upIndicator);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeIndicatorItem({commit}, indicatorId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/indicator/${indicatorId}`)
				.then((response) => {
					commit("REMOVE_INDICATOR_ITEM", indicatorId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
